import React from 'react';
import { Image } from '@plone/volto/components';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { defineMessages, useIntl } from 'react-intl';

import './facultyCard.less';

const messages = defineMessages({
  seeMore: {
    id: 'seeMore',
    defaultMessage: 'Approfondisci',
  },
  seeMorePersonInfo: {
    id: 'seeMorePersonInfo',
    defaultMessage: 'Informazioni aggiuntive su ',
  },
});

const FacultyCard = ({ item }) => {
  const intl = useIntl();

  return (
    <div className="faculty-card">
      <div className="image">
        <Image
          src={item.photo}
          alt={item.fullname}
          title={item.fullname}
          imageField="image"
          responsive={true}
        />
      </div>
      {(item.fullname || item.role || item.url) && (
        <div className="content">
          {item.fullname && <p className="fullname">{item.fullname}</p>}
          {item.role && <p className="description">{item.role}</p>}
          {item.url && (
            <UniversalLink
              aria-label={
                intl.formatMessage(messages.seeMorePersonInfo) + item.fullname
              }
              className="link"
              href={flattenToAppURL(item.url)}
            >
              {intl.formatMessage(messages.seeMore)}
            </UniversalLink>
          )}
        </div>
      )}
    </div>
  );
};

export default FacultyCard;
